export default "__VITE_ASSET__COY7Y4fG__"